import { useState, useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/Common";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Users, Car } from "@phosphor-icons/react";
import Clients from "@/pages/Clients";
import Vehicles from "@/pages/Vehicles";

export default function Cadastros() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initial = searchParams.get("tab") === "veiculos" ? "veiculos" : "clientes";
  const [tab, setTab] = useState(initial);
  const [prefillClientId, setPrefillClientId] = useState(null);

  useEffect(() => {
    if (searchParams.get("tab") !== tab) {
      setSearchParams({ tab }, { replace: true });
    }
  }, [tab, searchParams, setSearchParams]);

  const handleClientCreated = useCallback((clientId) => {
    setPrefillClientId(clientId);
    setTab("veiculos");
  }, []);

  const handlePrefillConsumed = useCallback(() => {
    setPrefillClientId(null);
  }, []);

  return (
    <div data-testid="cadastros-page">
      <PageHeader
        title="Cadastros"
        subtitle="Gerencie clientes e veículos da oficina em um só lugar."
      />

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-6">
          <TabsTrigger value="clientes" data-testid="tab-clientes">
            <Users size={14} className="mr-1.5" /> Clientes
          </TabsTrigger>
          <TabsTrigger value="veiculos" data-testid="tab-veiculos">
            <Car size={14} className="mr-1.5" /> Veículos
          </TabsTrigger>
        </TabsList>

        <TabsContent value="clientes">
          <Clients embedded onClientCreated={handleClientCreated} />
        </TabsContent>
        <TabsContent value="veiculos">
          <Vehicles
            embedded
            prefillClientId={prefillClientId}
            onPrefillConsumed={handlePrefillConsumed}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
